<template>
  <b-card>
    <b-card-body>
      <span>{{displayTime}}&nbsp;</span>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  name: "CountDown",
  data: () => {
    return {
      future: new Date(),
      _timerHandle: -1,
      displayTime: "0:0:0:0"
    };
  },
  props: {
    date: String
  },
  created: function() {
    let vm = this;
    vm.future = new Date(vm.date);
    vm.tick();
  },
  methods: {
    tick: function() {
      let vm = this;
      if (vm._timerHandle > 0) clearTimeout(vm._timerHandle);
      vm._timerHandle = setTimeout(vm.tick, 1000);
      let diff = Math.floor(
        (vm.future.getTime() - new Date().getTime()) / 1000
      );
      vm.displayTime = vm.dhms(diff);
    },
    ConvertDbDateToJsDate: function(dbDate) {
      var t = dbDate.split(/[- :]/);
      var jsDate = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
      return jsDate;
    },
    dhms: function(t) {
      this.days = Math.floor(t / 86400);
      t -= this.days * 86400;
      this.hours = Math.floor(t / 3600) % 24;
      t -= this.hours * 3600;
      this.minutes = Math.floor(t / 60) % 60;
      t -= this.minutes * 60;
      this.seconds = t % 60;
      return [
        this.days + "d",
        this.hours + "h",
        this.minutes + "m",
        this.seconds + "s"
      ].join(" ");
    },
    updateTimer: function(newDate) {
      let vm = this;
      vm.future = new Date(newDate);
    }
  }
};
</script>
<style scoped>
</style>